import { client as request } from "./request";

export interface WeatherNews {
  place: string;
  latitude: string;
  longitude: string;
  weatherNews: Weather[];
}

/**
 * ある日の天気
 */
export interface Weather {
  // type: WeatherType;
  type: string;
  date: string;
}

/**
 * 天気種別
 */
export type WeatherType =
  | "wind"
  | "rain"
  | "snow"
  | "sleet"
  | "fog"
  | "cloudy"
  | "clear-day"
  | "clear-night"
  | "partly-cloudy-day"
  | "partly-cloudy-night";

/**
 * 日ごとの天気予報を取得する
 */
export async function getWeatherNews(projectId: string | number) {
  const res: WeatherNews = await request.get("get_daily_weathernews.php", {
    projectId
  });
  res.weatherNews = res.weatherNews || [];
  return res;
}
